export default {
    menu: {
        statistics: "Statistics",
        workers: "Workers",
        wallet: "Wallet",
        settings: "Settings",
        rating: "Rating",
        referral: "Referral Program",
        documents: "Documents",
        logout: "Log out",
        language: "Language",
    },

    login: {
        email: "Email",
        password: "Password",
        remember: "Remember me for 30 days",
        signin: "Sign in",
        forgot: "Forgot password?",
        noAccount: "Don't have an account yet?",
        createAccount: "Create Account",
        emailNotVerified: "Email not verified",
        sendVerifyCode: "Send verification code",
        goToVerify: "Enter verification code",
    },

    verifyEmail: {
        title: "Email Verification",
        sendCode: "Send code",
        codeSent: "Code sent to your email",
        confirm: "Confirm",
        backToLogin: "Sign in",
    },

    registration: {
        email: "Email*",
        referral: "Referral ID",
        password: "Password*",
        passwordConfirm: "Password Confirmation*",
        accountName: "Account Name",
        next: "Next",
        emailVerification: "Email Verification",
        createAccount: "Create Account",
        suspended: "Registration is temporarily suspended",
        registerTitle: "Register a New Account",
        alreadyAccount: "Already have an account?",
        signIn: "Sign In",
    },

    restore: {
        email: "Email*",
        next: "Next",
        securityVerification: "Security Verification",
        resendCode: "Resend code",
        resendCodeSent: "Code sent",
        newPassword: "New Password*",
        confirmPassword: "Confirm Password*",
        changePassword: "Change Password",
        title: "Restore Password",
        noAccount: "Don't have an account yet?",
        createAccount: "Create Account",
    },

    welcome: {
        title: "Welcome on board!",
        subtitle: "Ready to rock your income?",
        start: "Let's go!",
    },

    settings: {
        title: "Settings",
        security: "Security",
        password: "Password",
        change: "Change",
        email: "Email",
        attachment: "Attachment",
        verified: "Verified",
        attach: "Attach",
        notifications: "Notifications",
        twoFactor: "Two-Factor Authentication",
        usedForSecurity: "Used for notification and security modifications",
        usedForWithdrawals: "Used for withdrawals and security modifications",
        telegramBot: "Telegram Bot",
        financialOperations: "Financial Operations",
        miningPayout: "Mining Payout",
        miningRewards: "Mining Rewards",
        walletWithdrawal: "Wallet Withdrawal",
        miningStatuses: "Mining Statuses",
        onlineOfflineWorker: "Online/Offline Worker",
        dropHashrate: "Drop hasrate",
        miningPools: "Mining Pools",
        save: "Save",
        watcherLinks: "Watcher Links",
        addWatcher: "Add Watcher",
        permission: "Permission",
        url: "Url",
        inputWLName: "Input WL Name",
        autoSwap: "Auto Swap",
        autoSwaps: "Auto Swaps",
        enableAutoSwap: "Enable Auto Swap",
        enableAutoPayout: "Enable Auto Payout",
        disableAutoPayout: "Disable Auto Payout",
        autoPayoutEnabled: "Enable Auto Payout minimal {min} BTC to {wallet} address",
        payouts: "Payouts",
        minimumValue: "Minimum Value",
        address: "Address",
        enterBTCWallet: "Enter BTC wallet address",
        enterWalletAddress: "Enter wallet address",
        selectNetwork: "Select network",
        oldPassword: "Enter your old password*",
        newPassword: "Enter your new password*",
        changePassword: "Change Password",
        passwordConfirm: "Password confirmation*",
        watcherName: "Name",
        watcherTags: "Tags",
        watcherWorkers: "Workers",
        watcherTransactions: "Transactions",
        watcherBalance: "Balance",
        watcherHashrate: "Hashrate",
        watcherDelete: "DEL",
        watcherLogin: "Login",
        mail: "Mail",
        tg: "TG",
        legal: {
            title: "Legal Entity Details",
            desc: "Company details, phone, the credit address, and the watcher link are filled into the mining report.",
            legalName: "Organization / IE Name",
            inn: "INN (Tax ID)",
            kpp: "KPP",
            ogrn: "OGRN / OGRNIP",
            legalAddress: "Legal Address",
            phone: "Phone",
            creditAddress: "Identifier address",
            watcher: "Watcher-link",
            bankAccount: "Bank Account",
            bankBik: "Bank BIC",
            bankName: "Bank Name",
            ph_legalName: "LLC Example / IE Ivanov I.I.",
            ph_inn: "7700000000",
            ph_kpp: "770001001",
            ph_ogrn: "1027700000000",
            ph_legalAddress: "Moscow, Example St., 1",
            ph_phone: "+79991234567",
            ph_creditAddress: "bc1q...",
            ph_watcher: "https://...",
            ph_bankAccount: "40702810000000000000",
            ph_bankBik: "044525225",
            ph_bankName: "Sberbank PJSC",
            saved: "Saved",
            saving: "Saving...",
            error: "Failed to save. Please try again.",
            err_inn: "INN must be 10 or 12 digits",
            err_bik: "BIC must be exactly 9 digits",
            err_account: "Bank account must be exactly 20 digits",
            err_kpp: "KPP must be exactly 9 digits",
            err_phone: "Phone: 5+ characters, digits, +, space, brackets, or a hyphen",
        },
    },

    workers: {
        title: "Workers",
        total: "Total",
        global: "Global",
        hashrate: "Hashrate",
        chart: "Chart",
        tags: "Tags",
        set: "Set",
        setHashrate: "Set Hashrate",
        extraInfo: "Additional information",
        reportTitle: "Additional information",
        reportBrand: "Equipment brand",
        reportModel: "Equipment model",
        reportSerial: "Serial number",
        reportHours: "Hours in operation",
        reportStratumHours: "Hours on our stratum",
        reportSave: "Save",
        reportSaving: "Saving...",
        reportSaved: "Saved",
        reportError: "Could not save",
        addDevice: "Add Device",
        delete: "Delete",
        deleteWorker: "Delete Worker",
        deleteConfirm: "This action will delete all the data about selected worker",
        addFirstDevice: "Add your first Device here",
        orHere: "Or here",
        connectingWorker: "Connecting new Worker",
        workerConfig: "Worker configuration",
        customizeName: "Customize worker name",
        stratumConfig: "Set up your stratum configuration:",
        tag: "Tag",
        addTag: "Add Tag",
        removeTag: "Remove Tag",
        enterTag: "Enter tag",
        tagName: "Tag name",
        download: "Download",
        history: "History",
        detailed: "Detailed",
        scale: "Scale",
        date: "Date",
        selectDate: "Select Date",
        selectTag: "Select Tag...",
        selectPeriod: "Select Period",
        close: "Close",
        name: "Name",
        edit: "edit",
        add: "Add",
        workerName: "Worker Name",
        current: "Current",
        hashrate1h: "Hashrate / 1h",
        hashrate24h: "Hashrate / 24h",
        avgFor1h: "Average for 1h",
        avgFor24h: "Average for 24h",
        rejectRate24h: "Avg. Reject rate / 24h",
        rejectRate: "Reject rate / 24h",
        all: "All",
        active: "Active",
        inactive: "Inactive",
        avgHashrate: "Average hashrate",
        rejectRateShort: "Reject rate",
        connected: "Connected",
        ipAddress: "IP address",
        infoLabel: "Info",
        lastShare: "Last Share",
        allTags: "All Tags",
        minerTags: "Miner Tags",
        clickToAddTag: "(click to add tag on miner)",
        clickToRemoveTag: "(click to remove tag from miner)",
    },

    // Exchange rates (Exchange tab in rating)
    exchangeRates: {
        sourceImex: "IMEX",
        sourceOther: "Other sources",
        sourceOtherHint: "Bybit and Bank of Russia",
        sourceLabel: "Rate source",
        noImexData: "IMEX rates have not been collected yet. You can show other sources.",
        noData: "No rates for this period.",
        usdtRub: "USDT/RUB",
        derivedNote: "* derived rate: BTC/USDT × USDT/RUB (there was no direct BTC/RUB trade that day)",
        loading: "Loading…",
    },

    wallet: {
        title: "Wallet",
        deposit: "Deposit",
        withdraw: "Withdraw",
        withdrawal: "Withdrawal",
        exchange: "Exchange",
        swap: "Swap Tokens",
        walletAddress: "Wallet address",
        enterWalletAddress: "Enter wallet address",
        transferAmount: "Transfer amount",
        enterAmount: "Enter amount",
        max: "MAX",
        min: "MIN",
        send: "SEND",
        confirm: "C O N F I R M",
        securityVerification: "Security Verification",
        confirmWithdrawal: "Confirm Withdrawal",
        youGet: "You get",
        expectedBTC: "Expected, BTC",
        totalPaidBTC: "Total paid, BTC",
        history: "History",
        date: "Date",
        copy: "Copy",
        selectNetwork: "Select network",
        type: "Type",
        token: "Token",
        status: "Status",
        info: "Info",
        networkFee: "Network fee",
        networkMin: "Network min",
        amount: "Amount",
        tag: "Tag",
        enterTag: "Enter tag",
        priceBTC: "Price BTC",
        available: "Available: {available} {coin}",
        availableLabel: "Available",
        swapFromTo: "Swap {from} to {to}",
        swapError: "Failed to complete the swap. Please try again later.",
        youWithdraw: "You withdraw: {amount} {wallet}",
        toWalletAddress: "to the wallet: {address} {addressTag} network: {network}",
        withdrawRub: "Withdraw to RUB",
        rubWithdrawal: "RUB Withdrawal Request",
        currentRate: "Current rate",
        noBankDetails: "Please fill in your bank details in profile settings",
        rubRequests: "My Requests",
        requestSent: "Request submitted. We will contact you.",
        statusPENDING: "Pending",
        statusPROCESSING: "Processing",
        statusCOMPLETED: "Completed",
        statusFAILED: "Rejected",
        depositType: "Deposit",
        imexPendingBanner: "You have a pending IMEX Custody withdrawal. Complete it to finish the transfer:",
        imexPoolLiquidity: "Available in pool (total IMEX liquidity, not your personal balance): {amount}",
        imexFrameTitle: "IMEX Custody Confirmation",
        imexFrameDescription: "Your withdrawal is being processed. Please complete the confirmation in IMEX Custody.",
        imexFrameOpen: "Proceed to Confirmation",
        imexCancelWithdrawal: "Cancel Withdrawal",
        imexCancelConfirm: "Are you sure you want to cancel this withdrawal?",
        imexCommission: "IMEX commission",
        kucoinUsdt: "USDT (KuCoin)",
        withdrawUnavailable: "Withdrawal unavailable",
        networkLoadError: "Failed to load networks. Please try again later.",
        depositAddressError: "Failed to get deposit address. Please try again later.",
        withdrawRequestError: "Failed to create withdrawal request. Please try again later.",
    },

    dashboard: {
        income: "Income",
        difficulty: "Difficulty",
        totalPaid: "Total paid, BTC",
        selectPeriod: "Select Period",
        bonus: "Bonus",
        vipPayrate: "VIP Payrate",
        hashrate: "Hashrate",
        hashrate24h: "Hashrate 24h",
        incomeBTC: "Income, BTC",
        bonusBTC: "Bonus, BTC",
        rateSatTH: "Rate, Sat/TH",
        total: "Total",
        rateLabel: "Rate:",
        incomeRUB: "Amount, ₽",
        rubPaid: "Paid, ₽",
        rubExpect: "Expected, ₽",
    },

    rating: {
        title: "Rating",
        pools: "Mining Pools",
        chart: "Chart",
        ratingPool: "Rating / Pool",
        ratingInfo: "The rating is based on actually working equipment connected through anonymous accounts.",
        pool: "Pool",
        payrateLabel: "Payrate, SAT",
        payrateSmall: "payrate",
        addToChart: "Add to chart",
        days: "{n} days",
    },

    referral: {
        title: "Referral Program",
        referralId: "Referral ID",
        invite: "Invite",
        agentInfo: "Agent Info",
        becomeAgent: "become an agent",
        becomeReferral: "become an referral",
        agentCode: "input agent code",
        referrals: "Referrals",
        rank: "Rank:",
        inviteCode: "Invite referral code:",
        name: "Name",
        email: "Email",
        hashrate: "Hashrate",
        incomeFee: "Income fee, %",
        bonusFee: "Bonus fee, %",
        referralBonus: "Referral bonus, %",
        save: "save",
        bonus: "Bonus",
    },

    documents: {
        title: "Documents",
        incomeReport: "Mining Income Certificate",
        incomeReportDesc: "Generate an income report for the selected period. Suitable for tax declarations and accounting purposes.",
        periodStart: "Start date",
        periodEnd: "End date",
        placeholderStart: "01.01.2026",
        placeholderEnd: "31.12.2026",
        download: "Download PDF",
        downloadXml: "Download XML",
        generating: "Generating...",
        error: "Failed to generate document. Please try again later.",
        note: "Document is generated from your account data. All amounts are in BTC at the date of accrual.",
        miningTitle: "Digital currency mining report",
        miningDesc: "The button fills the form with account data for the selected month. Fields the account does not store stay empty.",
        generate: "Generate report",
        year: "Reporting year",
        month: "Reporting month",
        correction: "Correction number",
        taxOffice: "Tax office code",
        taxOfficeHint: "4 digits, used in the FNS file name",
        energy: "Electricity, kWh",
        energyPh: "0.00",
        phone: "Phone",
        email: "Email",
        legalName: "Legal name",
        inn: "INN",
        kpp: "KPP",
        ogrn: "OGRN",
        legalAddress: "Legal address",
        operationType: "Operation type",
        onPool: "Digital currency is held on the mining pool",
        credited: "Digital currency was credited to an identifier address",
        currency: "Digital currency",
        minedAmount: "Amount mined",
        creditedAmount: "Amount credited",
        poolAddress: "Mining pool identifier address",
        creditAddress: "Identifier address",
        watcher: "Watcher-link",
        equipment: "Equipment",
        worker: "Worker",
        nominal: "Nominal, TH",
        brand: "Brand",
        model: "Model",
        serial: "Serial number",
        hours: "Hours in operation",
        needValue: "Not stored in the account",
        sectionMain: "General",
        sectionContact: "Contact",
        sectionLegal: "Details",
        sectionCurrency: "Digital currency",
        addEquipment: "Add equipment",
        missingNote: "The pool address comes from the pool settings. Save a credit address here; if a withdrawal already happened, the latest one is filled in.",
        creditSave: "Save address",
        creditFromWithdrawal: "Filled from the latest withdrawal",
        stratumHours: "Hours on our stratum",
    },

    common: {
        showMore: "Show more",
        loading: "Loading...",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        add: "Add",
        change: "Change",
        close: "Close",
        copy: "Copy",
        next: "Next",
        send: "SEND",
        confirm: "Confirm",
        select: "Select",
        subscribe: "Subscribe to РУСБИТ Newsletter",
        termsOfService: "Terms of Service",
        iAgree: "I have read and agreed with",
        passwordMust: "Password must:",
    },
};
